import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReferralMessageComponent } from './referral-message.component';
import { AppAnalyticsModule } from '../../../directives/app-analytics.module';

@NgModule({
    declarations: [ReferralMessageComponent],
    imports: [CommonModule, AppAnalyticsModule],
    exports: [ReferralMessageComponent],
})
export class ReferralMessageModule {}
